import * as Yup from 'yup';

export const OverpayNoteValidationSchema = () =>
	Yup.object().shape({
		noteDate: Yup.date().required('Note date is required.'),
	});